import React from "react";
import * as Mui from "@mui/material";
import {
  designColors,
  designRadii,
  designShell,
  designType,
} from "services/constants/designTokens";

// Tinted square icon tile used at the start of a section/card header. Teal
// by default; pass `accent` ({ color, bg }, e.g. one of detailAccentPalette)
// to give a section its own colour.
export const IconTile = ({ icon, size = 48, accent }) => (
  <Mui.Box
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: designRadii.card,
      backgroundColor: accent?.bg || designColors.tealTint,
      color: accent?.color || designColors.tealDark,
    }}
  >
    {icon}
  </Mui.Box>
);

// Page section card: the shared sectionCard surface with an icon tile, a
// title, a helper line and an optional right-aligned action (e.g. an "Add"
// button). First used by Administration > Support & Contacts and Administration
// > Organisation, which show the same sections read-only and
// editable respectively.
export const IconSectionCard = ({ icon, accent, title, subtitle, action, children }) => (
  <Mui.Box
    component="section"
    sx={{ ...designShell.sectionCard, p: { xs: 2, md: 2.5 } }}
  >
    <Mui.Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems={{ xs: "stretch", sm: "center" }}
      justifyContent="space-between"
      sx={{ mb: 2.5 }}
    >
      <Mui.Stack direction="row" spacing={2} alignItems="center" sx={{ minWidth: 0 }}>
        <IconTile icon={icon} accent={accent} />
        <Mui.Box sx={{ minWidth: 0 }}>
          <Mui.Typography component="h2" sx={designType.panelTitle}>
            {title}
          </Mui.Typography>
          <Mui.Typography sx={designType.pageSubtitle}>{subtitle}</Mui.Typography>
        </Mui.Box>
      </Mui.Stack>
      {action}
    </Mui.Stack>
    {children}
  </Mui.Box>
);

export default IconSectionCard;
